import { Modal } from 'antd';
import { PredictionHistoryPanel } from './PredictionHistoryPanel';

const HistoryPredictions = ({ isModalVote, setIsModalVote, IP, FP }) => {
  const handleCancelVote = () => {
    setIsModalVote(false);
  };

  return (
    <Modal
      className="modal-jun88k36 modal-history"
      title="DANH SÁCH LỊCH SỬ DỰ ĐOÁN"
      open={isModalVote}
      footer={null}
      onCancel={handleCancelVote}
    >
      <div className="content-km content-history">
        <PredictionHistoryPanel IP={IP} FP={FP} />
      </div>
    </Modal>
  );
};

export default HistoryPredictions;
export { PredictionHistoryPanel } from './PredictionHistoryPanel';
export { WorldCupHistoryResultsPanel } from './WorldCupHistoryResultsPanel';
